/**
 * Đường dẫn endpoint API backend — dùng với apiClient.
 *
 * Hàm động (propertyId, contactId...) nhận ID và trả path tương ứng.
 * Prefix /admin cho các route quản trị.
 */

/** Tập hợp path API — map 1-1 với backend routes */
export const API_ROUTES = {
  authRegister: '/auth/register',
  authLogin: '/auth/login',
  authGoogle: '/auth/google',
  authApple: '/auth/apple',
  authLogout: '/auth/logout',
  authMe: '/auth/me',
  authAvatar: '/auth/me/avatar',
  categories: '/categories',
  contacts: '/contacts',
  myContacts: '/contacts/mine',
  contactDetails: (contactId) => `/admin/contacts/${contactId}`,
  favorites: '/favorites',
  favoriteDetails: (propertyId) => `/favorites/${propertyId}`,
  locations: '/locations',
  properties: '/properties',
  propertyAreas: '/properties/areas',
  propertySuggestions: '/properties/suggestions',
  propertySimilar: (propertyId) => `/properties/${propertyId}/similar`,
  propertyDetails: (propertyId) => `/properties/${propertyId}`,
  adminDashboard: '/admin/dashboard',
  adminContacts: '/admin/contacts',
  adminProperties: '/admin/properties',
  adminPropertyDetails: (propertyId) => `/admin/properties/${propertyId}`,
  adminPropertyApproval: (propertyId) => `/admin/properties/${propertyId}/approve`,
  adminPropertyImages: (propertyId) => `/admin/properties/${propertyId}/images`,
  adminPropertyImageDetails: (propertyId, imageId) =>
    `/admin/properties/${propertyId}/images/${imageId}`,
  adminUsers: '/admin/users/admins',
  adminManagedUsers: '/admin/users',
  adminManagedUser: (userId) => `/admin/users/${userId}`,
  adminUserPassword: (adminId) => `/admin/users/admins/${adminId}/password`,
};
